// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { userSetupSettingsStyles } from "@steiner/Overrides/Widgets/UserSetup/UserSetupSettings";
import AlertInfo from "@steiner/XDL/Icons/AlertInfo";
import { color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

userSetupSettingsStyles.acceptConditions = {
    css: css`
        ${StyledButton} ${TypographyStyle} {
            font-size: 12px;
            line-height: 12px;
        }
    `,
    mergeCss: true,
};

userSetupSettingsStyles.approverSelectLabelWrapper = userSetupSettingsStyles.roleSelectLabelWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;

        ${IconWrapper} {
            cursor: pointer;
            vertical-align: middle;
            &:hover {
                color: ${color("common.ui9")};
            }
        }
    `,
};

userSetupSettingsStyles.roleSelectHelpIcon = {
    src: AlertInfo,
    size: 14,
    color: "common.ui8",
};

userSetupSettingsStyles.approverSelectTooltip = {
    iconProps: {
        size: 14,
        src: AlertInfo,
        color: "common.ui8",
    },
    mergeCss: true,
};

userSetupSettingsStyles.termsLink = {
    css: css`
        margin-left: 5px;
    `,
}